module.exports = {"createFolder":"Create Folder","parentFolder":"Parent Folder","newFolderName":"New folder name","uploadDocument":"Upload document","folder":"Folder","documents":"Documents","uploadedFilesLength":"Uploaded files length:","upload":"Upload","totalFilesLength":"Total files length:"}


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales/technicaldocumentation/en.json
// module id = GzPh
// module chunks = 1